export const ROLE_LABELS = { ATAQUE: 'Ataque', BUFF: 'Buff', SUPORTE: 'Suporte' };

export const STATUS_LABELS = { PENDING: 'Pendente', PAID: 'Pago', DONATED: 'Doado' };

export const TABS = [
  { id: 'summary', label: 'Resumo Geral' },
  { id: 'expenses', label: 'Despesas do Clã' },
  { id: 'distribution', label: 'Distribuição dos Players' },
  { id: 'history', label: 'Histórico' },
];

// Fatias da divisão 30/20/50 a partir dos valores já persistidos. O último
// segmento absorve o arredondamento pra soma fechar em 100%.
export const splitSegments = (summary) => {
  const segments = [
    { key: 'admin', label: 'Administrativo', amount: summary.adminCostAmount || 0 },
    { key: 'treasury', label: 'Caixa', amount: summary.treasuryAmount || 0 },
    { key: 'players', label: 'Players', amount: summary.pilotsShareAmount || 0 },
  ];
  const total = segments.reduce((acc, s) => acc + s.amount, 0);

  if (total === 0) {
    return segments.map((s) => ({ ...s, percent: 0 }));
  }

  let used = 0;
  return segments.map((s, index) => {
    const percent = index === segments.length - 1
      ? 100 - used
      : Math.round((s.amount / total) * 100);
    used += percent;
    return { ...s, percent };
  });
};

export const filterByRole = (rows, role) => (role ? rows.filter((r) => r.role === role) : rows);

// Usa o fuso local do navegador: datas vêm do backend com offset (-03:00).
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '—');

// Envolve uma função assíncrona e marca como `stale` qualquer resposta de uma
// chamada que já foi superada por outra mais nova (ex.: cliques rápidos).
export const latestOnly = (fn) => {
  let latest = 0;
  return async (...args) => {
    const call = ++latest;
    try {
      const value = await fn(...args);
      return { stale: call !== latest, value };
    } catch (err) {
      if (call !== latest) return { stale: true, value: undefined };
      throw err;
    }
  };
};
